import { NgModule } from '@angular/core';
import { ViewportComponent } from './viewport.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        ViewportComponent,
    ],
    exports: [
        ViewportComponent,
    ],
    imports: [
        CommonModule
    ]
})
export class ViewportModule {
}
